import React, { useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import HeaderComponents from "../../Components/HeaderComponent";
import NftsData from "../../Components/NftsData";
import { Container } from "../../Components/StyledComponents/StyledComponents";
import ActionRules from "./ActionRules";
import BidHistory from "./BidHistory";
// import ImageView from "./ImageView";
import ImageSlider from "./imagesSlider";
import OnChainData from "./OnChainData";

const Root = styled.div`
  width: 100%;
`;

const Div = styled.div``;

const BreadCrumbs = styled.div`
  color: ${(p) => p.theme.colors.skyColor};
  font-size: ${(p) => p.theme.font.size.xs};
  margin-bottom: ${(p) => p.theme.spacing.md};
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.md};
  }
`;
const Span = styled.span`
  opacity: 0.4;
`;


const NftsDetailPage = () => {
  const [nfts, setNfts] = useState(NftsData);


  let { id } = useParams();
  const nftDetail = nfts.filter((nft) => {
    return nft.id == id;
  });
 
  // console.log("/////////", nftDetail)

  return (
    <Root>
      {nftDetail.map((nft) => {
        return (
          <Div key={nft.id}>
            <Container>
              <HeaderComponents title="NFT MARKET" />
              <BreadCrumbs>
                Auction Market <Span>/ Mount</Span>
              </BreadCrumbs>
            </Container>
            <ImageSlider/>
            {/* <ImageView nft={nft} /> */}
            <Container>
              <OnChainData nft={nft} />
              <BidHistory nft={nft} />
              <ActionRules nft={nft} />
            </Container>
          </Div>
        );
      })}
    </Root>
  );
};

export default NftsDetailPage;
